import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import { hero, contactHref } from '../content/portfolio';

const Hero: React.FC = () => {
  const { language } = useLanguage();
  const reduce = useReducedMotion();
  const c = hero[language];
  const cvHref = language === 'pt' ? '/cv/cv-pt.pdf' : '/cv/cv-en.pdf';
  const href = contactHref(language);
  const external = href.startsWith('http');

  const rise = (delay: number) => ({
    initial: reduce ? false : { opacity: 0, y: 40 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.9, delay, ease: [0.2, 0.7, 0.2, 1] as const },
  });

  return (
    <section
      id="home"
      data-ink="#e8e6e1"
      data-field="#0c0b09"
      className="flex flex-col justify-between gap-24 bg-code-bg pb-10 lg:min-h-[100svh] pt-28 text-code-text sm:pb-14"
    >
      <div className="container-responsive">
        <h1 className="font-serif font-medium leading-[0.9] tracking-[-0.035em] text-[13.5vw] md:text-[clamp(56px,12.5vw,210px)]">
          <motion.span className="block" {...rise(0)}>{c.line1}</motion.span>
          <motion.span className="block" {...rise(0.12)}>{c.line2}</motion.span>
        </h1>
      </div>

      <div className="container-responsive grid items-end gap-8 md:grid-cols-[minmax(0,36rem)_auto] md:justify-between">
        <motion.p className="text-xl leading-snug" {...rise(0.35)}>
          {c.sub}
        </motion.p>
        <motion.div className="flex flex-wrap items-center gap-x-8 gap-y-4" {...rise(0.5)}>
          <a
            href={href}
            target={external ? '_blank' : undefined}
            rel={external ? 'noopener noreferrer' : undefined}
            className="inline-flex bg-accent-primary px-7 py-4 text-xl font-medium text-code-bg transition-transform hover:-translate-y-0.5 active:translate-y-0"
          >
            {c.primary}
          </a>
          <a href={cvHref} download className="text-xl underline underline-offset-4 transition-opacity hover:opacity-70">
            {c.secondary}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
